import { routesName, useGetAuthorityGetAccessById, useNavigation } from "core";
import React,{ memo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Detail } from "../../../templates";

const OprationalAccessDetail = memo(() => {
  const {_navigateWithParams}=useNavigation()
  const { i18n } = useTranslation();
  const { id } = useParams();
  
  const { data,isFetching } = useGetAuthorityGetAccessById({accessId :`${id}`});
  
  return (
    <>
      <Detail
        isLoading={isFetching}
        title={i18n.t("oprationalAccess")}
        data={data}
        onClick={() => {
          _navigateWithParams(routesName.EDITOPRATIONALACCESS, {
            id: id,
          });
        }}
      />
    </>
  );
});
export { OprationalAccessDetail };
